import PropTypes from 'prop-types';

export default PropTypes.shape({
  "name": PropTypes.string, // this name is unique per fabricator
  "order": PropTypes.number,
  "bgImage": PropTypes.string,
  "enabled": PropTypes.bool,
  "featureGroups": PropTypes.array
})
